import { createActions } from 'redux-actions';

export const { updateBrush } = createActions({
	UPDATE_BRUSH: pos => ({ pos })
});

export default { updateBrush };
